import materialUI from "material-UI";
import styled from "styled-components";

export const Container = styled(materialUI.Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 72px;
  width: 200px;
  border-radius: 8px;
`;

export const Background = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 72px;
  width: 200px;
  border-radius: 8px;
  background: #333;
`;
